export default __webpack_public_path__ + "media/Slice-3.83678fc5.png";